import styled from 'styled-components';

const AssistantWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ChatInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px;
  position: relative;

  & > div {
    width: 100%;
  }

  .suggestions-container {
    position: absolute;
    bottom: 100%;
    right: 18px;
    z-index: 9999;
    margin-bottom: 8px;

    @media (max-width: 768px) {
      width: calc(100% - 36px);
      right: 18px;
      left: 18px;
    }
  }
`;

export {
  AssistantWrapper,
  ChatInputWrapper
}; 